import { Component } from '@angular/core';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: '[nc-device-registration]',
  templateUrl: './device-registration.component.html',
  standalone: false,
})
export class DeviceRegistrationComponent extends AnonymousContentPage {

  constructor() {
    super();
  }
}
